import axios from "axios";
import router from "@/router";
import { API_BASE_URL } from "@/config";
// import { showLoading, hideLoading } from "@/stores/loading";

const api = axios.create({
  baseURL: `${API_BASE_URL}`,
  headers: {
    "Content-Type": "application/json",
  },
});

// request interceptor
api.interceptors.request.use(
  (config) => {
    // showLoading();

    const token = localStorage.getItem("auth_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const lang = localStorage.getItem("lang") || "fa";
    config.headers.lang = lang;

    return config;
  },
  (error) => {
    // hideLoading();
    return Promise.reject(error);
  }
);

// response interceptor
api.interceptors.response.use(
  (response) => {
    // hideLoading();
    return response;
  },
  (error) => {
    // hideLoading();

    if (error.response && error.response.status === 401) {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("user_info");
      router.push("/");
    }

    return Promise.reject(error);
  }
);

export default api;
